import { useState } from 'react'

import { Text, TextInput } from '@mantine/core'

const AutomatedRuleOverview = ({ ruleName, setRuleName }) => {
  const [nameError, setNameError] = useState(null)
  const [touched, setTouched] = useState(false)

  const handleChange = (e) => {
    const value = e.target.value
    setRuleName(value)

    if (touched) {
      if (!value.trim()) {
        setNameError('Rule name is required')
      } else {
        setNameError(null)
      }
    }
  }

  const handleBlur = () => {
    setTouched(true)
    if (!ruleName.trim()) {
      setNameError('Rule name is required')
    } else {
      setNameError(null)
    }
  }

  return (
    <div className="space-y-4">
      <Text size="xs" fw={400} className="text-doubleNickel-gray-500">
        OVERVIEW
      </Text>
      <div className="space-y-3">
        <div className="flex flex-row items-center justify-between">
          <Text size="xs">
            Name
            <span className="text-doubleNickel-error-500">{' *'}</span>
          </Text>
          <div className="w-[250px]">
            <TextInput
              placeholder={`Enter an automated rule name`}
              size="xs"
              value={ruleName}
              onChange={(e) => handleChange(e)}
              error={nameError}
              classNames={{
                input: 'text-xs text-right',
              }}
              onBlur={handleBlur}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AutomatedRuleOverview
